import store from "../src/store";
import { isDevEnvironment } from "../src/utils/environment";

export const Can = (action) => {
    const selectedDepartment = store.getters.getUserData.selectedDepartment;
    const rights = store.getters.getUserData.rights[selectedDepartment];

    if (!rights) {
        console.warn(`[Can] Geen rechten gevonden voor department "${selectedDepartment}" (recht "${action}" geweigerd). Controleer of deze gebruiker een rol heeft toegewezen voor dit department.`);
        return false;
    }

    return rights.includes(action);
};
